import { Link } from "react-router-dom";

// Inline internal links in content text: [anchor](/path)
export const Rich = ({ text }) => {
  const re = /\[([^\]]+)\]\((\/[^)\s]*)\)/g;
  const out = [];
  let last = 0;
  let m;
  while ((m = re.exec(text || ""))) {
    out.push(text.slice(last, m.index));
    out.push(<Link key={m.index} to={m[2]} className="text-[#5EE6D0] underline underline-offset-4 transition-colors hover:text-foreground">{m[1]}</Link>);
    last = m.index + m[0].length;
  }
  out.push((text || "").slice(last));
  return out;
};

export const Crumbs = ({ items, testid }) => (
  <nav aria-label="Breadcrumb" data-testid={testid} className="-ml-2 mb-4">
    <ol className="flex flex-wrap items-center gap-1 text-[13px] text-muted-foreground">
      {items.map(([label, to], i) => (
        <li key={label} className="flex items-center gap-1">
          {i > 0 && <span aria-hidden="true" className="text-[#E9C98B]/70">›</span>}
          {to ? <Link to={to} className="inline-flex min-h-[44px] items-center px-2 hover:text-foreground transition-colors">{label}</Link>
            : <span aria-current="page" className="px-2 text-[#F3DDAE]">{label}</span>}
        </li>
      ))}
    </ol>
  </nav>
);

export const ArticleCard = ({ a, testid }) => (
  <Link to={a.path} data-testid={testid}
    className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-[#E9C98B]/35 hover:bg-white/[0.05]">
    <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#F3DDAE]/80">{a.type === "guide" ? "Guide" : "Etsy tags"}</span>
    <span className="mt-3 font-display text-xl leading-snug text-foreground">{a.type === "guide" ? a.h1 : `Etsy Tags for ${a.product}`}</span>
    <span className="mt-3 line-clamp-3 text-sm leading-relaxed text-muted-foreground">{a.meta_description}</span>
    <span className="mt-auto pt-5 text-sm text-[#5EE6D0] group-hover:underline underline-offset-4">Read →</span>
  </Link>
);

export const ContentCta = () => (
  <aside data-testid="content-cta" className="my-12 rounded-2xl border border-[#E9C98B]/30 bg-gradient-to-br from-[#E9C98B]/[0.07] to-transparent p-6 sm:p-8">
    <p className="font-display text-2xl leading-snug">Fixing hundreds of listings? Do it safely.</p>
    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">AetherTags scores every listing, drafts title and tag fixes with reasons, locks your bestsellers, and pushes nothing without your approval — with one-click undo.</p>
    <Link to="/#waitlist" data-testid="content-cta-waitlist" className="btn-aurora mt-5 inline-flex min-h-[44px] items-center rounded-full px-6 text-sm">Join the founding-member waitlist</Link>
  </aside>
);
